import script from "./ChecklistModeloEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistModeloEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistModeloEditPage.vue?vue&type=style&index=0&id=6b2b0ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2b0ff8"]])

export default __exports__